import { useRequestWithClientId } from '../hooks/useRequest';
import { graphql } from '../graphql';
import { useQuery } from '@tanstack/react-query';
import { queryClient } from '../stores/queryClient';
export const GET_SDK_STATUS = graphql(`
  query GetSdkStatus($lob: String!) {
    getSdkStatus(input: { lineOfBusiness: $lob }) {
      ok
    }
  }
`);
export const useRequestSdkStatus = (lineOfBusiness, clientId) => {
    const request = useRequestWithClientId(false, lineOfBusiness, clientId, GET_SDK_STATUS, { lob: lineOfBusiness });
    const { data, isError, isPending, isSuccess } = useQuery({
        queryKey: ['SdkStatus'],
        queryFn: () => request(),
    }, queryClient);
    return { isAvailable: data === null || data === void 0 ? void 0 : data.getSdkStatus.ok, isError, isSuccess, isPending };
};
//# sourceMappingURL=useRequestSdkStatus.js.map